module.exports = __webpack_public_path__ + "img/ooredoo.7ad7782f.svg";